import { style } from '../layer.css.ts';
import { finePointerHover } from '../theme-v2/fine-pointer-hover.ts';
import { hairline } from '../theme-v2/hairline.ts';
import { themeV2 } from '../theme-v2/vars.ts';
import { borderRadius, space } from '../tokens';
import { typography } from '../typography';

export const cardV2Root = style({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  padding: space.s16,
  backgroundColor: themeV2.color.bg.surface.default,
  boxShadow: hairline(themeV2.color.border.subtle),
  borderRadius: borderRadius.r16,
  color: themeV2.color.text.primary,
});

export const cardV2Hoverable = style({
  '@media': {
    [finePointerHover]: {
      transition: 'box-shadow 150ms ease',
      selectors: {
        '&:hover': {
          boxShadow: hairline(themeV2.color.border.hover),
        },
      },
    },
  },
});

export const cardV2Header = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s8,
  minWidth: 0,
});

export const cardV2Body = style({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

export const cardV2Footer = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s16,
  width: '100%',
  minWidth: 0,
});

export const cardV2FooterRule = style({
  height: 1,
  width: '100%',
  backgroundColor: themeV2.color.border.subtle,
  border: 0,
  margin: 0,
});

export const cardV2FooterContent = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s12,
  minWidth: 0,
});

export const cardV2Title = style({
  ...typography.titleMd,
  color: themeV2.color.text.primary,
  margin: 0,
});

export const cardV2Description = style({
  ...typography.bodyMd,
  color: themeV2.color.text.quaternary,
  margin: 0,
});
